import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { SanityContentLogoText } from '../../../../../graphql-types';
import { RichText } from '../../../../components/2.0version/richText/RichText';
import { usePageContext } from '../../../../hooks/contexts/usePageContext';
import * as styles from './dualLogoText.module.scss';

interface IDualLogoTextProps {
  data: SanityContentLogoText;
}

export const DualLogoText = ({ data }: IDualLogoTextProps) => {
  const { lang } = usePageContext();
  const image = getImage(data.logo?.image?.asset?.gatsbyImageData);
  const alt = data.logo?.alt ?? 'Logo placeHolder';
  return (
    <div className={styles.mainWrapper}>
      {image && <GatsbyImage image={image} alt={alt} />}
      <RichText value={data?._rawText?.text?.[lang]} />
    </div>
  );
};
